import { Button, Flex } from 'antd';
import { useTranslation } from 'react-i18next';

type CollapsibleFilterFooterProps = {
  show: boolean;
  expanded: boolean;
  onToggle: () => void;
};

/** "Show more" / "Show less" link placed below a filter section (outside Checkbox.Group). */
export function CollapsibleFilterFooter({
  show,
  expanded,
  onToggle,
}: CollapsibleFilterFooterProps) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <Flex justify="start" align="start">
      <Button
        type="link"
        size="small"
        onClick={onToggle}
        data-testid={
          expanded ? 'filtered-listing-show-less' : 'filtered-listing-show-more'
        }
      >
        {expanded ? t('SHOW_LESS') : t('SHOW_MORE')}
      </Button>
    </Flex>
  );
}
